import React from 'react';
import styles from './style/dateRange.module.css';

interface DateRangeProps {
  startDate?: string,
  endDate?: string,
}

function DateRange({ startDate, endDate }: DateRangeProps) {
  return (
    <div className={styles.container}>
      <ul>
        <li>
          <span className="small-print">Start Date</span>
          <strong>{startDate || '-'}</strong>
        </li>
        <li>
          <span className="small-print">End Date</span>
          <strong>{endDate || '-'}</strong>
        </li>
      </ul>
    </div>
  );
}

DateRange.defaultProps = {
  startDate: '',
  endDate: '',
}

export default DateRange;
